import { StreakStatusType } from "core/state/Trackers/TrackerType";
import { useTranslation } from "react-i18next";
import { StatusModal } from "shared/UI/StatusModal/StatusModal";
import { ReactComponent as FirstStreakIcon } from "shared/assets/first-streak.svg";
import { ReactComponent as NewStreakIcon } from "shared/assets/new-streak.svg";
import { MoodStreakStatusType } from "shared/request/myHealthyAdvantageApi";

export const StreakStatusModal = ({ event, visible, handleClose }: { event?: MoodStreakStatusType; visible: boolean; handleClose: () => void }) => {
  const { t } = useTranslation();
  const hasValidEvent = event === StreakStatusType.Zero || event === StreakStatusType.Active;

  if (!visible || !event || hasValidEvent) {
    return null;
  }

  const Icon = event === StreakStatusType.FirstStreak ? FirstStreakIcon : NewStreakIcon;

  return (
    <StatusModal
      data={{
        image: <Icon />,
        ...t(`home.moodTracker.status.${event}`, { returnObjects: true }),
      }}
      status="info"
      handleConfirm={handleClose}
    />
  );
};
